module.exports = __webpack_public_path__ + "img/zlindex41.c5a75093.png";